var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_4398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60433 3.60171H7.18508V11.2794C7.18508 11.3793 7.26208 11.461 7.3562 11.461H8.63963C8.73374 11.461 8.81075 11.3793 8.81075 11.2794V3.60171H10.3958C10.5391 3.60171 10.6182 3.42695 10.5305 3.30894L8.13481 0.0907833C8.06636 -0.00226632 7.93374 -0.00226632 7.86529 0.0907833L5.46957 3.30667C5.38187 3.42695 5.46101 3.60171 5.60433 3.60171Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8289 10.5986H14.5455C14.4513 10.5986 14.3743 10.6803 14.3743 10.7802V14.2752H1.62567V10.7802C1.62567 10.6803 1.54866 10.5986 1.45455 10.5986H0.171123C0.0770053 10.5986 0 10.6803 0 10.7802V15.2738C0 15.6755 0.305882 16.0001 0.684492 16.0001H15.3155C15.6941 16.0001 16 15.6755 16 15.2738V10.7802C16 10.6803 15.923 10.5986 15.8289 10.5986Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_4398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic_upload.2b4888017bd00b145547739ce6057d8e.svg";
export { ForwardRef as ReactComponent };